export const updateObject = (oldObject, updatedProperties) => {
    let parametros = {
        ...oldObject,
        ...updatedProperties
    };
    // const oldValues = (localStorage.getItem("redux-storage-worker") != null)?localStorage.getItem("redux-storage-worker"):[];
    // localStorage.setItem("redux-storage-worker", JSON.stringify(parametros));

    return parametros
};